import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { claimFormStore } from '../../../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New contact',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const { id, supplierId } = Route.useParams();
    const reload = claimFormStore.use.reload();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <ContactEdit
            action={['add']}
            type="SUPPLIER"
            entity="supplier"
            entityId={supplierId}
            onSuccess={() => void reload()}
            claimId={id}
            showIsPrimaryForType={false}
        />
    );
}
